import { Grid } from "@mui/material";
import TextFieldComponent from "./textField";
import moment from "moment";

/**
 * CustomerDetails component displays customer-related information in a grid layout.
 * It uses a configuration array to dynamically render fields.
 * Each field can have properties like label, value, importance, type, and column width.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.order - The order object containing customer details.
 * @returns {JSX.Element} A grid of text fields displaying customer details.
 */
const CustomerDetails = (props) => {
  const { order } = props;

  return (
    <Grid container spacing={2} style={{ margin: "8px" }}>
      {fieldsConfig.map((field) => (
        <Grid item xs={12} sm={field.col || 6} key={field.id}>
          <TextFieldComponent
            label={field.label}
            value={
              field.type === "date" && order[field.value]
                ? moment.utc(order[field.value]).local().format("YYYY-MM-DD")
                : order[field.value] || ""
            }
            important={field.important}
            type={field.type}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default CustomerDetails;

/**
 * Fields configuration for the customer details component.
 * This array can be used to dynamically generate fields in the component.
 * Each object in the array represents a field with its properties.
 * @type {Array<{ label: string, value: string, important?: boolean, type?: string, col?: number, id: string }>}
 */
const fieldsConfig = [
  {
    id: "apple-task-id",
    label: "Apple Task ID",
    value: "order_number",
    important: true,
    col: 6,
  },
  {
    id: "apple-ritm-id",
    label: "Apple RITM ID",
    value: "ritm_id",
    important: true,
    col: 6,
  },
  {
    id: "priority",
    label: "Priority",
    value: "priority",
    col: 6,
  },
  {
    id: "urgency",
    label: "Urgency",
    value: "urgency",
    col: 6,
  },
  {
    id: "customer",
    label: "Customer",
    value: "name",
    important: true,
    col: 6,
  },
  {
    id: "phone",
    label: "Phone",
    value: "phone",
    col: 6,
  },
  {
    id: "created-date",
    label: "Created Date",
    value: "opened_utc",
    type: "date",
    important: true,
    col: 6,
  },
  {
    id: "due-date",
    label: "Due Date",
    value: "duedate_utc",
    type: "date",
    col: 6,
  },
  {
    id: "so-number",
    label: "Sales Order Number",
    value: "so_number",
    type: "text",
    important: false,
    col: 6,
  },
  {
    id: "if-number",
    label: "IF Number",
    value: "if_number",
    type: "text",
    important: false,
    col: 6,
  },
    {
    id: "order-title",
    label: "Title",
    value: "title",
    type: "text",
    important: false,
    col: 6,
  },
  {
    id: "tracking-number",
    label: "Tracking Number",
    value: "tracking_number",
    type: "text",
    important: false,
    col: 6,
  },
  {
    id: "order-description",
    label: "Description",
    value: "description",
    type: "textarea",
    important: false,
    col: 6,
  },
  {
    id: "internal-memo",
    label: "Internal Memo",
    value: "internal_memo",
    type: "textarea",
    important: false,
    col: 6,
  },
  {
    id: "additional-comments",
    label: "Additional Comments",
    value: "additionalcommentsStr",
    type: "textarea",
    important: false,
    col: 12,
  },
];
